import { UserRole } from 'libs/utils/src/lib/player-portals/constants';

export const parseUserRole = (
  role: string | undefined,
): UserRole | undefined => {
  const key = role?.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

  switch (key) {
    case 'player':
      return UserRole.Player;
    case 'manager':
      return UserRole.Manager;
    case 'caddie':
      return UserRole.Caddie;
    case 'randaadmin':
      return UserRole.RandaAdmin;
    case 'lcqplayer':
      return UserRole.LCQPlayer;
    case 'lcqcaddie':
      return UserRole.LCQCaddie;
    case 'lcqmanager':
      return UserRole.LCQManager;
    case 'admin':
      return UserRole.RandaAdmin;
    default:
      return undefined;
  }
};
